import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import SET_USER from './types';
export default _defineProperty({}, SET_USER, function (state, payload) {
  var currentState = state;
  currentState.user = payload;
});